<!-- @format -->

<ng-container *transloco="let t">
  <fudis-expandable [level]="2" [title]="t('FREE_EDIT.COURSE_UNIT_EXPANDABLE.TITLE')" [closed]="false">
    <ng-template fudisExpandableContent>
      <fudis-section [title]="t('FREE_EDIT.COURSE_UNIT_EXPANDABLE.ADD_COURSE_UNITS')" [level]="3">
        <fudis-section-content>
          <sis-course-unit-search-select
            [cooperationNetworkIds]="cooperationNetworkIds"
            [currentUniversityOrgId]="currentUniversityOrgId"
            [crossStudyFeaturesEnabled]="crossStudyFeaturesEnabled"
            [curriculumPeriodIds]="curriculumPeriodIds"
            [excludedCourseUnitIds]="getCourseUnitIdsExcludedFromSearch()"
            [helpText]="
              t('PLAN_EDIT.SELECTION_MODAL.SEARCH_HELP_TEXT') + ' ' + t('PLAN_EDIT.SELECTION_MODAL.STUDIES_ALREADY_IN_PLAN_HELP_TEXT')
            "
            (updateSelected)="selectCourseUnitFromSelectList($event)" />
          @for (selectedCourseUnit of selectedCourseUnits(); track selectedCourseUnit.id) {
            @let isInPlan = planStructureContext.validatablePlan().isCourseUnitInPlan(selectedCourseUnit);
            <div class="sis-pt-sm">
              <sis-plan-structure-course-unit
                [courseUnit]="selectedCourseUnit"
                [headingLevel]="4"
                [action]="'select-to-plan'"
                [selected]="isInPlan"
                (actionChange)="handleToggleCourseUnit({ courseUnit: selectedCourseUnit, isInPlan })">
              </sis-plan-structure-course-unit>
            </div>
          }
        </fudis-section-content>
      </fudis-section>
      <fudis-section [title]="t('FREE_EDIT.COURSE_UNIT_EXPANDABLE.ADD_UNPLANNED_ATTAINMENTS_TITLE')" [level]="3" class="sis-pt-md">
        <fudis-section-content>
          @let ucuas = unplannedCourseUnitAttainments();
          @let uccuas = unplannedCustomCourseUnitAttainments();
          @if (ucuas.length > 0 || uccuas.length > 0) {
            @for (unplannedCourseUnitAttainment of ucuas; track unplannedCourseUnitAttainment.id) {
              @if (unplannedCourseUnitAttainment.courseUnitId | courseUnit | async; as unplannedAttainedCourseUnit) {
                @let isInPlan = planStructureContext.validatablePlan().isCourseUnitInPlan(unplannedAttainedCourseUnit);
                <div class="sis-pt-sm">
                  <sis-plan-structure-course-unit
                    [courseUnit]="unplannedAttainedCourseUnit"
                    [headingLevel]="4"
                    [action]="'select-to-plan'"
                    [selected]="isInPlan"
                    [showAttainment]="false"
                    (actionChange)="handleToggleCourseUnit({ courseUnit: unplannedAttainedCourseUnit, isInPlan })">
                  </sis-plan-structure-course-unit>
                </div>
              }
            }
            @for (unplannedCustomCourseUnitAttainment of uccuas; track unplannedCustomCourseUnitAttainment.id) {
              @let isInPlan =
                planStructureContext.validatablePlan().isCustomCourseUnitAttainmentInPlan(unplannedCustomCourseUnitAttainment);
              <div class="sis-pt-sm">
                <sis-plan-structure-custom-course-unit-attainment
                  [customCourseUnitAttainment]="unplannedCustomCourseUnitAttainment"
                  [headingLevel]="4"
                  [action]="'select-to-plan'"
                  [selected]="isInPlan"
                  (actionChange)="
                    handleToggleCustomCourseUnitAttainment({ customCourseUnitAttainment: unplannedCustomCourseUnitAttainment, isInPlan })
                  ">
                </sis-plan-structure-custom-course-unit-attainment>
              </div>
            }
          } @else {
            <fudis-body-text>{{ t("FREE_EDIT.COURSE_UNIT_EXPANDABLE.NO_UNPLANNED_ATTAINMENTS") }}</fudis-body-text>
          }
        </fudis-section-content>
      </fudis-section>
      <fudis-section [title]="t('FREE_EDIT.COURSE_UNIT_EXPANDABLE.SAVED_COURSE_UNITS_TITLE')" [level]="3" class="sis-pt-md">
        <fudis-section-content>
          @let scus = savedCourseUnits();
          @let sccuas = savedCustomCourseUnitAttainments();
          @if (scus.length > 0 || sccuas.length > 0) {
            @for (savedCourseUnit of scus; track savedCourseUnit.id) {
              @let isInPlan = planStructureContext.validatablePlan().isCourseUnitInPlan(savedCourseUnit);
              <div class="sis-pt-sm">
                <sis-plan-structure-course-unit
                  [courseUnit]="savedCourseUnit"
                  [headingLevel]="4"
                  [action]="'select-to-plan'"
                  [selected]="isInPlan"
                  [showAttainment]="false"
                  (actionChange)="handleToggleCourseUnit({ courseUnit: savedCourseUnit, isInPlan })">
                </sis-plan-structure-course-unit>
              </div>
            }
            @for (savedCustomCourseUnitAttainment of sccuas; track savedCustomCourseUnitAttainment.id) {
              @let isInPlan = planStructureContext.validatablePlan().isCustomCourseUnitAttainmentInPlan(savedCustomCourseUnitAttainment);
              <div class="sis-pt-sm">
                <sis-plan-structure-custom-course-unit-attainment
                  [customCourseUnitAttainment]="savedCustomCourseUnitAttainment"
                  [headingLevel]="4"
                  [action]="'select-to-plan'"
                  [selected]="isInPlan"
                  (actionChange)="
                    handleToggleCustomCourseUnitAttainment({ customCourseUnitAttainment: savedCustomCourseUnitAttainment, isInPlan })
                  ">
                </sis-plan-structure-custom-course-unit-attainment>
              </div>
            }
          } @else {
            <fudis-body-text>{{ t("FREE_EDIT.COURSE_UNIT_EXPANDABLE.NO_SAVED_COURSE_UNITS") }}</fudis-body-text>
          }
        </fudis-section-content>
      </fudis-section>
    </ng-template>
  </fudis-expandable>
</ng-container>
